let riskArrData = [
  {
    kindCode: 'A',
    riskTextArr: [
        {
            text: '0元',
            code: '0'
        },{
            text: '300元',
            code: '300'
        },{
            text: '500元',
            code: '500'
        },{
            text: '1000元',
            code: '1000'
        },{
            text: '2000元',
            code: '2000'
        }
    ]
  },
  {
    kindCode: 'B',
    riskTextArr: [
        {
          text: '10万元',
          code: '100000'
        },{
          text: '15万元',
          code: '150000'
        },{
          text: '20万元',
          code: '200000'
        },{
          text: '30万元',
          code: '300000'
        },{
          text: '50万元',
          code: '500000'
        },{
          text: '100万元',
          code: '1000000'
        },{
          text: '150万元',
          code: '1500000'
        },{
          text: '200万元',
          code: '2000000'
        },{
          text: '250万元',
          code: '2500000'
        },{
          text: '300万元',
          code: '3000000'
        },{
          text: '350万元',
          code: '3500000'
        },{
          text: '400万元',
          code: '4000000'
        },{
          text: '450万元',
          code: '4500000'
        },{
          text: '500万元',
          code: '5000000'
        },{
          text: '550万元',
          code: '5500000'
        },{
          text: '600万元',
          code: '6000000'
        },{
          text: '650万元',
          code: '6500000'
        },{
          text: '700万元',
          code: '7000000'
        },{
          text: '750万元',
          code: '7500000'
        },{
          text: '800万元',
          code: '8000000'
        },{
          text: '850万元',
          code: '8500000'
        },{
          text: '900万元',
          code: '9000000'
        },{
          text: '950万元',
          code: '9500000'
        },{
          text: '1000万元',
          code: '10000000'
        }
      ]
  },{
    kindCode: 'L',
    riskTextArr: [
        {
          text: '2000元',
          code: '2000'
        },{
          text: '5000元',
          code: '5000'
        },{
          text: '10000元',
          code: '10000'
        },{
          text: '20000元',
          code: '20000'
        }
      ]
  },{
    kindCode: 'FA',
    riskTextArr: [
        {
          text: '5%',
          code: '5'
        },{
          text: '10%',
          code: '10'
        },{
          text: '15%',
          code: '15'
        },{
          text: '20%',
          code: '20'
        }
      ]
  },{
    kindCode: 'FB',
    riskTextArr: [
        {
          text: '5%',
          code: '5'
        },{
          text: '10%',
          code: '10'
        },{
          text: '15%',
          code: '15'
        },{
          text: '20%',
          code: '20'
        }
      ]
  },{
    kindCode: 'FD3',
    riskTextArr: [
        {
          text: '5%',
          code: '5'
        },{
          text: '10%',
          code: '10'
        },{
          text: '15%',
          code: '15'
        },{
          text: '20%',
          code: '20'
        }
      ]
  },{
    kindCode: 'FD4',
    riskTextArr: [
        {
          text: '5%',
          code: '5'
        },{
          text: '10%',
          code: '10'
        },{
          text: '15%',
          code: '15'
        },{
          text: '20%',
          code: '20'
        }
      ]
  },{
    kindCode: 'T1',
    riskTextArr: [
        {
          text: '2次',
          code: '2'
        }, {
          text: '7次',
          code: '7'
        }, {
          text: '12次',
          code: '12'
        }, {
          text: '17次',
          code: '17'
        }, {
          text: '22次',
          code: '22'
        }
      ]
  },{
    kindCode: 'C4',
    riskTextArr: [
        {
          text: '1000元',
          code: '1000'
        },{
          text: '1500元',
          code: '1500'
        },{
          text: '2000元',
          code: '2000'
        },{
          text: '3000元',
          code: '3000'
        },{
          text: '5000元',
          code: '5000'
        },{
          text: '10000元',
          code: '10000'
        }
      ]
  },{
    kindCode: 'S1',
    riskTextArr: [
      {
        text: '2万元',
        code: '20000'
      },{
        text: '4万元',
        code: '40000'
      },{
        text: '5万元',
        code: '50000'
      },{
        text: '10万元',
        code: '100000'
      },{
        text: '15万元',
        code: '150000'
      },{
        text: '20万元',
        code: '200000'
      }
    ]
  },{
    kindCode: 'S2',
    riskTextArr: [
      {
        text: '2万元',
        code: '20000'
      },{
        text: '4万元',
        code: '40000'
      },{
        text: '5万元',
        code: '50000'
      },{
        text: '10万元',
        code: '100000'
      },{
        text: '15万元',
        code: '150000'
      },{
        text: '20万元',
        code: '200000'
      }
    ]
  },{
    kindCode: 'S3',
    riskTextArr: [
      {
        text: '2万元',
        code: '20000'
      },{
        text: '4万元',
        code: '40000'
      },{
        text: '5万元',
        code: '50000'
      },{
        text: '10万元',
        code: '100000'
      },{
        text: '15万元',
        code: '150000'
      },{
        text: '20万元',
        code: '200000'
      }
    ]
  }
]
export default {
    riskArrData: riskArrData,
  }


// WEBPACK FOOTER //
// ./src/utils/riskDate.js